<template>
  <div ref="search">
    <div v-if="!storeState.gotBlocks" class="tw-flex tw-justify-center">
      <div class="tw-pt-32">
        <v-progress-circular
          indeterminate
          :size="100"
          :width="8"
          color="primary"
        >
        </v-progress-circular>
      </div>
    </div>
    <div v-else>
      <div>
        <div class="search-container2">
          <div class="search-underlay">
            <div v-html="underlay"></div>
          </div>
          <div class="search-text-container">
            <textarea 
              placeholder="Search" 
              v-focus
              ref="searchText" 
              v-model="storeState.searchTerm" 
              v-on:keyup="search"
              rows="1" 
              wrap="off" 
              class="search-text mousetrap" 
              spellcheck="false"
            >
            </textarea>
            <v-tooltip left dark color="#333">
              <template v-slot:activator="{ on }">
                <span v-on="on" class="save-search">
                  <v-btn icon @click="backToBlocks">
                    <v-icon>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </span>
              </template>
              <span class="tooltip-text">Close</span>
              <span class="key">
                <span class="key-inner">esc</span>
              </span>
            </v-tooltip>
            <!-- <v-tooltip left dark color="#333">
              <template v-slot:activator="{ on }">
                <button v-on="on" class="soup-btn" @click="backToBlocks">
                  <v-icon>mdi-close</v-icon>
                </button>
              </template>
              <span class="tooltip-text">Close</span>
              <span class="key">
                <span class="key-inner">esc</span>
              </span>
            </v-tooltip> -->
          </div>
        </div>
        <div ref="searchSuggestions" class="search-suggestions" v-if="showSuggestions">
          <div v-if="storeState.searchSuggestions.length === 0" class="suggest-explain">
            Find a code snippet, table, column, or tag using <strong>#tagname</strong>
          </div>
          <div ref="suggestionList">
            <div
              :data-uuid="row.uuid"
              :ref="'suggestion_' + index"
              :id="'suggestion_' + index"
              v-for="(row, index) in storeState.searchSuggestions"
              :key="row.uuid"
              @mouseover="hoverRow(row, index, true)"
              @mouseleave="hoverRow(row, index, false)"
              :class="{
                  'active': (index === storeState.searchIndex), 
                  'row-hover': storeState.searchIndex < 0,
                  'searchResultRows': true,
                  }"
              >
              <v-row>
                <v-col cols="12" sm="4" class="text-left dense-col clickable suggest-title" @click="rowClick" :data-uuid="row.uuid" :data-type="row.type" :data-index="index">
                  <v-icon small class="blocks-icon left suggestion-icons">{{ row.icon }}</v-icon>
                  {{row.title}}
                </v-col>
                <v-col cols="12" sm="8" class="text-left dense-col clickable" @click="rowClick" :data-uuid="row.uuid" :data-type="row.type" :data-index="index">
                  {{row.details}}
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    
</div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import debounce from 'debounce';
import { store } from '../store.js';
import draggable from 'vuedraggable';
import _ from 'lodash';


export default {
  mounted() {
    window.bus.$on('focusEl', (details) => {
      setTimeout(() => {
        let ref = this.$refs[details.el]
        if (ref) ref.focus()
      }, 0);
    });
    this.getSearchSuggestions({searchTerm: this.storeState.searchTerm})
  },
  data() {
    return {
      storeState: store.state,
      store: store,
      showSuggestions: true,
      blockHoverIndex: -1,
      searching: store.state.searching,
      favorites: false,
      scheduled: false,
      searchResults: [],
      searchSuggestions: store.state.searchSuggestions,
      saved: false,
      blockCategories: [
        {id: 0, name: 'All', f: function(self) {
          self.favorites = false
          self.scheduled = false
          self.saved = false
          }
        },
        {id: 1, name: 'Saved', f: function(self) {
          console.log('Saved...')
          self.favorites = false
          self.scheduled = false
          self.saved = true
          // this.$forceUpdate()
          }
        },
        {id: 2, name: 'Scheduled', f: function(self) {
          console.log('favorites...')
          self.favorites = false
          self.saved = false
          self.scheduled = true
          // this.$forceUpdate()
          }
        },
        {id: 3, name: 'Favorites', f: function(self) {
          console.log('favorites...')
          self.scheduled = false
          self.saved = false
          self.favorites = true
          }
        },
      ],
      underlay: '',
      tempSearch: '',
      newTag: '',
      tags: [],
    };
  },
  components: {
    draggable,
  },
  watch: {
    'storeState.tableLoading': {
      handler: function (newVal, oldVal) {
        console.log('watch tableLoading', 'newval: ', newVal, '   oldVal:', oldVal)
        this.showSuggestions = false
        // if (!newVal) {
          
        // } 
      }
    },
    'storeState.searchTerm': {
      handler: function (newVal, oldVal) {
        this.showSuggestions = true
      }
    },
  },
  filters: {
    fromNowFilter: function (data) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${data.email}`]
      if (details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    }
  },
  methods: {
    moment: function () {
      return moment();
    },
    backToBlocks() {
      this.storeState.searching = false
      this.$router.push({ name: 'Blocks'}).catch(err => console.error(err))
    },
    getUserPic(email) {
      let u = this.storeState.settings.team.members.find(u => u.email === email)
      if (u) return u.pic
      return ''
    },
    fromNowRunFormat: function (data) {
      if (!data) return 'Never run'
      return moment(data/1000).fromNow()
    },
    deleteBlock(block) {
      Vue.delete(this.storeState.blocks, block.uuid)
      store.deleteBlock(block)
    },
    runBlock(block) {
      this.$parent.openBlock(block.uuid)
    },
    getSourceName(row) {
      let s = this.storeState.allSources.find(s => s.block_uuid === row.source.uuid)
      if (s && s.name) return `${s.name}`
      return ''
    },
    hoverRow(row, index, hover) {
      if (hover) {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = index
      } else {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = -1
      }
    },
    rowClick(e) {
      console.log('rowClick: ', e)
      var self = this
      let suggestion = self.storeState.searchSuggestions[e.currentTarget.dataset.index]
      if (suggestion.type === 'code') {
        console.log('e.currentTarget.id: ', e.currentTarget.dataset.uuid)
        this.$parent.openBlock(e.currentTarget.dataset.uuid)
      } else if (suggestion.type === 'snippet') {
        console.log('e.currentTarget.id: ', e.currentTarget.dataset.uuid)
        this.$parent.openBlock(e.currentTarget.dataset.uuid)
      } else {
        let sql = store.generateMetaSql(suggestion)
        let blockId = store.uuidv4()
        this.storeState.newBlocks.push(blockId)
        this.storeState.searchTerm = suggestion.title
        this.$router.push({ name: 'Tables', params: {id: blockId }}).catch(err => console.error(err))
      }
    },
    getFromNow: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    },
    getTags: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.tags) {
        return details.tags
      } else {
        return ''
      }
    },
    openSettings() {
      this.storeState.cmdkParentCmd = 'settings'
      this.$parent.openCmdK({cmdkParentCmd: 'settings', cmdkInput: ''})
    },
    newBlock() {
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      console.log('newBlocks: ', this.storeState.newBlocks)
      this.$router.push({ name: 'Run', params: {id:  blockId}}).catch(err => console.error(err))
    },
    validateSearch(val) {
      console.log('val term: ', val)
      this.storeState.searchTerm = this.newTag
      if (val.startsWith('#')) return true
      return false
    },
    filterBlocks(opts) {
      var blockResults = []
      let searchTerms = opts.searchTerm.toLowerCase().split(' ').filter(t => t.length > 0)
      var tags = []
      for (let index = 0; index < searchTerms.length; index++) {
        const term = searchTerms[index];
        if (term.includes('#')) {
          var theseTags = store.findHashtags(term)
          if (theseTags.length > 0) tags = tags.concat(theseTags.map(t => t.replace('#', '')))
        }
      }
      for (const blockId in this.storeState.blocks) {
        var addBlock = 0
        let block = this.storeState.blocks[blockId]
        if (tags.length > 0 && block.tags.length > 0) {
          for (let i = 0; i < tags.length; i++) {
            let tag = tags[i];
            for (let i2 = 0; i2 < block.tags.length; i2++) {
              let blockTag = block.tags[i2];
              if ((blockTag && blockTag.text && blockTag.text.startsWith(tag)) || tag === '') {
                addBlock+=1
              }
            }
          }
        }
        for (let index = 0; index < searchTerms.length; index++) {
          const term = searchTerms[index];
          if (block.title.toLowerCase().includes(term)) {
            addBlock+=1
          } else if (block.code.toLowerCase().includes(term)) {
            addBlock+=1
          } else if (block.destination.ss_id) {
            let blockSummary = store.getBlockSummary(block)
            if (blockSummary.toLowerCase().includes(term)) {
              addBlock+=1
            }
          }
        }
        if (addBlock - searchTerms.length >= 0) blockResults.push(block)
      }
      if (blockResults.length === 0) return []
      blockResults = blockResults.slice(0, 20)
      return blockResults.sort((a, b) => { return b.viewedOn - a.viewedOn;}) 
    },
    everyLetterMatch(searchTerm, searchIn) {
      searchTerm = searchTerm.toLowerCase()
      var include = true
      var searchTermLen = searchTerm.length
      var matches = 0
      var startMatch = searchIn.startsWith(searchTerm)
      for (let i = 0; i < searchTerm.length; i++) {
          if (!searchIn.includes(searchTerm[i].toLowerCase())) {
            include = false
            break
          } else {
            matches++
            //this chops off where the last letter was found, this means search letters need to be 
            //the same order as the match, e.g. segev = segment.events, but segev != vesg
            searchIn = searchIn.slice(searchIn.indexOf(searchTerm[i].toLowerCase()))
          }
      }
      var ratio = (matches * startMatch) * 1.0 / searchTermLen
      return {include: include, matches: matches, ratio: ratio}
    },
    getSearchSuggestions(opts) {
      let blockResults = this.filterBlocks({searchTerm: opts.searchTerm})
      this.storeState.searchSuggestions = []
      let columns = []
      if (this.storeState.dbMeta && !opts.searchTerm.includes('.')) { //get columns
        var i = 0
        while ((i < this.storeState.dbMeta.df.length) && this.storeState.searchSuggestions.length < 5) {
          let meta = this.storeState.dbMeta.df[i];
          // if (meta.column_name.includes(opts.searchTerm)) { 
          let match = this.everyLetterMatch(opts.searchTerm, meta.column_name)
          if (match.include) {
            let suggestion = {
              title: meta.column_name,
              details: `column in ${meta.table_schema}.${meta.table_name}`,
              icon: 'mdi-table-column',
              uuid: `${meta.table_schema}.${meta.table_name}.${meta.column_name}`,
              sql: {table: `${meta.table_schema}.${meta.table_name}`, column: `${meta.column_name}`},
              type: 'column',
              ratio: match.ratio
            }
            if (match.ratio > 1) {
              this.storeState.searchSuggestions.push(suggestion)
            } else {
              columns.push(suggestion)
            }
          }
          i++
        }
      }
      if (this.storeState.searchSuggestions.length < 5) {
        columns.sort((a, b) => { return b.ratio - a.ratio;})
        this.storeState.searchSuggestions = this.storeState.searchSuggestions.concat(columns.slice(0, 5 - this.storeState.searchSuggestions.length))
      }
      //add tables
      var i = 0
      let tables = []
      while (this.storeState.dbMeta && (i < this.storeState.dbMeta.tables.length) && this.storeState.searchSuggestions.length < 10) {
        let table = this.storeState.dbMeta.tables[i];
        let match = this.everyLetterMatch(opts.searchTerm, table)
        if (match.include) {
          let suggestion = {
            title: table,
            details: `table in ${table}`,
            icon: 'mdi-table',
            uuid: `${table}`,
            sql: {table: `${table}`},
            type: 'table',
          }
          if (match.ratio > 1) {
            this.storeState.searchSuggestions.push(suggestion)
          } else {
            tables.push(suggestion)
          }
        }
        i++
      }
      if (this.storeState.searchSuggestions.length < 10) {
        tables.sort((a, b) => { return b.ratio - a.ratio;})
        this.storeState.searchSuggestions = this.storeState.searchSuggestions.concat(tables.slice(0, 10 - this.storeState.searchSuggestions.length))
      }
      //add blocks
      if (!blockResults) return
      for (let i = 0; i < blockResults.length; i++) {
        let block = blockResults[i];
        let suggestionType = block.cellType === 'snippet' ? 'snippet' : 'code'
        let suggestionIcon = suggestionType === 'snippet' ? 'mdi-content-cut' : 'mdi-code-tags'
        let suggestion = {
          title: block.title || 'History',
          details: `${block.code.replace(/[\n\r]+/g, ' ')}`,
          icon: suggestionIcon,
          uuid: block.uuid,
          type: 'code',
        }
        this.storeState.searchSuggestions.push(suggestion)
      }
      // this.storeState.searchSuggestions = []
      // this.$forceUpdate()
    },
    search(e) {
      var self = this
      if (![13, 40, 38].includes(e.keyCode)) this.storeState.searchIndex = 0
      console.log('search term: ', this.storeState.searchTerm, e)
      if ([13, 40, 38].includes(e.keyCode)) {
        e.preventDefault()
        console.log('hit enter, up, down...')
        return
      }
      let opts = {searchTerm: this.storeState.searchTerm}
      this.getSearchSuggestions(opts)
      // this.filterBlocks(opts)
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `http://localhost:5000${path}`
      }
      return  `https://seekwell.io${path}`
    },
  },
  computed: {
  },
  created() {
    this.getSearchSuggestions = debounce(this.getSearchSuggestions, 100)
    

    // this.getFoodFacts();
    // this.renderUserEntries();
  },
};
</script>

<style>
.active {
  background-color: #eee;
  border-left-color: #333;
  border-left-style: solid;
  border-left-width: 3px;
}
.searchResultRows {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 40px;
  padding-right: 30px;
}

.vue-input-tag-wrapper {
    background-color: #fff;
    border: none;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}

.vue-input-tag-wrapper .new-tag {
    background: transparent;
    border: none;
    color: #333;
    flex-grow: 1;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 0px;
}

.vue-input-tag-wrapper .input-tag {
    background-color: #eee;
    border: 1px solid #eee;
    border-radius: 2px;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.search-input-container {
  padding-bottom: 20px;
  padding-left: 40px;
}
.row-sub-title {
  color: #ccc;
  padding-left: 10px;
}
.row-reminder {
  color: rgb(46, 170, 220);
  padding-left: 10px;
}
.save-search-q {
  float: right;
  margin-top: -35px;
  margin-right: 26px;
}
.block-search {
  float: right;
  margin-top: -35px;
  margin-right: 3px;
}

.search-container2 {
  padding-top: 20px;
  margin-left: 40px;
  margin-bottom: 20px;
}
.term-underlay {
  /* margin-left: 8px; */
  /* margin-top: 1px; */
  background: rgba(84, 172, 220, 0.2);
  box-shadow: 0 0 0 2px rgba(84, 172, 220, 0.2);
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-text {
  /* margin-left: 0px; */
  background: transparent;
  box-shadow: none;
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-partial {
  /* margin-left: 0px; */
  background: rgba(249, 150, 255, 0.2);
  box-shadow: none;
}
.search-underlay {
  position: absolute;
  width: 100%;
}
.search-text-container {
  position: absolute;
  width: 100%;
  height: 38px;
  font-size: 20px;
  outline: none;
}
#soupSearchContainer {
  display: -webkit-inline-box;
  position: absolute;
  width: 100%;
  margin-left: 20px;
}
.soup-queue-container {
  margin-left: 0px;
  margin-top: 15px;
  margin-bottom: 20px;
}
.row-title {
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-pic {
  display: inline;
}
.row-code {
  color: rgba(0, 0, 0, 0.5);
  /* display: inline; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-last-run {
  color: rgba(0, 0, 0, 0.5);
  float: right;
}
.block-icons {
  float: right;
}
.blocks-icon {
}
.sw-button {
  height: 40px;
  display: inline-block;
  line-height: 40px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: "Rubik";
  border-radius: 4px;
  text-align: center;
  background: #19774d;
  border: solid 1px #19774d;
  color: white;
  font-size: 0.875rem;
  text-decoration: none;
  padding: 0 1.5rem;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
  cursor: pointer;
}
.sw-button:hover {
  background-color: #50a779;
  border-color: #50a779;
}
.v-tab {
  min-width: 0px !important;
  padding-right: 46px !important;
  font-size: 20px !important;
  text-transform: none !important;
}
.left {
  float: left;
}
.nopad {
  padding-bottom: 0px !important;
  padding-top: 8px !important;
}
.favorite {
  padding-right: 10px !important;
  margin-top: 1px;
}
.search-suggestions {
  padding-top: 50px;
}
.dense-col {
  padding-left: 0px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  color: rgba(0, 0, 0, 0.5);
  /* display: inline; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.suggestion-icons {
  color: rgba(0, 0, 0, 0.5) !important;
  margin-top: 2px;
  padding-right: 5px !important;
}
.suggest-explain {
  padding-left: 40px;
}
.suggest-title {
  padding-left: 8px;
}
.search-table-container {
  padding-top: 40px;
}
.fetching-msg-code {
  /* background: #F5F7FA; */
  color: #666;
  padding: 5px;
  font-family: monospace;
  display: inline;
  word-wrap: break-word;
}
.dot-pulse {
  position: relative;
  display: inline-block;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #212529;
  color: #212529;
  box-shadow: 9999px 0 0 -5px #212529;
  animation: dotPulse 1.5s infinite linear;
  animation-delay: .25s;
}

.dot-pulse::before, .dot-pulse::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #212529;
  color: #212529;
}

.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px #212529;
  animation: dotPulseBefore 1.5s infinite linear;
  animation-delay: 0s;
}

.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px #212529;
  animation: dotPulseAfter 1.5s infinite linear;
  animation-delay: .5s;
}

@keyframes dotPulseBefore {
  0% {
    box-shadow: 9984px 0 0 -5px #212529;
  }
  30% {
    box-shadow: 9984px 0 0 2px #212529;
  }
  60%,
  100% {
    box-shadow: 9984px 0 0 -5px #212529;
  }
}

@keyframes dotPulse {
  0% {
    box-shadow: 9999px 0 0 -5px #212529;
  }
  30% {
    box-shadow: 9999px 0 0 2px #212529;
  }
  60%,
  100% {
    box-shadow: 9999px 0 0 -5px #212529;
  }
}

@keyframes dotPulseAfter {
  0% {
    box-shadow: 10014px 0 0 -5px #212529;
  }
  30% {
    box-shadow: 10014px 0 0 2px #212529;
  }
  60%,
  100% {
    box-shadow: 10014px 0 0 -5px #212529;
  }
}
.dot-pulse-container {
  display: inline-block;
  margin-right: 30px;
  margin-left: 30px;
}
</style>
